"use client";

import { FlexRowAlignCenter } from "@/components/Flex";
import SectionContainer from "@/features/LandingPages/components/SectionContainer";
import PlanOptions from "@/features/Payments/MainPlansPage/components/PlanOptions";
import {
    BULK_PRICING_UI,
    STUDENTS_PRICING_PICKER_UI,
    TEACHERS_PRICING_PICKER_UI,
} from "@/features/Payments/utils/constants";
import { themeColors } from "@/utils/themeColors";
import { useRouter } from "@bprogress/next";
import styles from "../../LandingPages/UploadLandingPages/components/medias/video-summarizer.module.css";
import { LandingMainContainer } from "../../LandingPages/components/styled/Containers";
import CustomizePlanButton from "../styled/CustomizePlanButton";

export const StudentAndTeacherPlans = ({ hideUltra = false }) => {
    const router = useRouter();

    const teacherItems = TEACHERS_PRICING_PICKER_UI(0).filter(item => !hideUltra || item.type !== "Teacher Ultra");
    const studentItems = STUDENTS_PRICING_PICKER_UI(0).filter(item => !hideUltra || item.type !== "Student Ultra");

    return (
        <LandingMainContainer
            accentColorDark="none"
            accentColorLight="none"
            className={styles.feedbackContainer}
            style={{ backgroundColor: themeColors.background, paddingBottom: "8rem" }}>
            <SectionContainer
                title="Get up to 30% off with a bulk purchase"
                subtitle="These are the plans we have available for teachers to pick from"
                sectionStyle={{ maxWidth: "unset" }}>
                <CustomizePlanButton />
                <PlanOptions
                    pricingOptions={teacherItems}
                    isSimpleClick
                    customOnClick={() => router.push("/schools/customize")}
                    containerStyle={{ margin: 0 }}
                />
                <PlanOptions
                    pricingOptions={studentItems}
                    isSimpleClick
                    customOnClick={() => router.push("/schools/customize")}
                />
            </SectionContainer>
        </LandingMainContainer>
    );
};

export const BulkPlans = () => {
    const studentItems = BULK_PRICING_UI();

    return (
        <FlexRowAlignCenter>
            <PlanOptions
                pricingOptions={studentItems}
                isSimpleClick
                customOnClick={() => {
                    window.open("https://form.fillout.com/t/vkoJGndDFXus", "_blank");
                }}
                containerStyle={{ margin: 0, alignItems: "stretch" }}
                princingCardSx={{
                    border: `1px solid ${themeColors.neutral1}`,
                    padding: "1.5rem",
                    backgroundColor: themeColors.neutralWhite,
                    height: "unset",
                    maxWidth: "24.1rem",
                    color: themeColors.neutralBlack,
                }}
                isForBulkPricing
                benefitCheckStyle={{
                    backgroundColor: themeColors.neutralBlack,
                    color: themeColors.neutralWhite,
                }}
            />
        </FlexRowAlignCenter>
    );
};
